import { render, staticRenderFns } from "./EPCC.vue?vue&type=template&id=072342eb&scoped=true&"
import script from "./EPCC.vue?vue&type=script&lang=js&"
export * from "./EPCC.vue?vue&type=script&lang=js&"
import style0 from "./EPCC.vue?vue&type=style&index=0&id=072342eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072342eb",
  null
  
)

export default component.exports